<template>
  <section class="container-sarah">
    <breadcrumb route="/inicio" :title="this.$t('areas.home')" />
    <!-- Intro Text -->
    <div class="hero">
      <div class="hero-body">
        <h1 class="title">
          {{ $t('exames.titulo') }}
        </h1>
        <p class="info_subtitle">
          {{ $t('exames.subtitulo') }}
        </p>
      </div>
    </div>
    <!-- Cards as a filter -->
    <div class="hero">
      <div class="hero-body">
        <h1 class="title_2">
          {{ $t('exames.filtro-resultado-dia') }}
          <a @click="removeFilter()" v-show="selectedFilter">{{
            $t('botoes.remover-filtro')
          }}</a>
        </h1>
        <filter-data :datas="datasPesquisa" @date-ready="setFilter" />
      </div>
    </div>
    <!-- table of content -->
    <div class="table">
      <div
        v-if="
          !dadosExames || !dadosExames.Exames || dadosExames.Exames.length === 0
        "
        class="container no-data"
      >
        <div class="img-container">
          <img
            src="~@/assets/images/banners/doctors_calendar.svg"
            alt="Atendimento"
          />
        </div>
        <h1 class="title">
          {{ $t('exames.sem-exames.titulo') }}
        </h1>
        <h2 class="subtitle">
          {{ $t('exames.sem-exames.subtitulo') }}
        </h2>
      </div>
      <template v-else>
        <b-table
          :data="dadosExames.Exames"
          :loading="isLoading"
          :is-row-checkable="(row) => row.Situacao === 'Visualizar'"
          :paginated="isPaginated"
          :current-page.sync="currentPage"
          :per-page="perPage"
          :pagination-simple="isPaginationSimple"
          :pagination-position="paginationPosition"
          :aria-page-label="this.$t('tabelas.pagina')"
          :aria-current-label="this.$t('tabelas.pagina-atual')"
        >
          <template slot-scope="exame">
            <b-table-column label="Data">
              {{ exame.row.Data }}
            </b-table-column>
            <b-table-column label="Horário">
              {{ exame.row.Horario }}
            </b-table-column>
            <b-table-column label="Descrição">
              {{ exame.row.NomeExame }}
            </b-table-column>
            <b-table-column class="actions" label="">
              <div
                v-if="
                  exame.row.Situacao === 'Visualizar' &&
                  (exame.row.IsExameImagem ||
                    exame.row.NomeExame.includes('Videofluoroscopia'))
                "
              >
                <b-button
                  @click="
                    openLaudoPDF(
                      exame.row.CodigoItemAtendimento,
                      exame.row.CodigoDocumento
                    )
                  "
                >
                  <span class="action-item">{{ $t('botoes.laudo') }}</span>
                  <i class="icon-ic_doc-list-blue" />
                </b-button>
              </div>
            </b-table-column>
            <b-table-column class="actions">
              <div
                v-if="
                  exame.row.Situacao === 'Visualizar' &&
                  [2, 7, 8, 9, 12, 16, 17].includes(exame.row.CodigoArea)
                "
              >
                <b-button
                  @click="
                    openLaudoPDF(
                      exame.row.CodigoItemAtendimento,
                      exame.row.CodigoDocumento
                    )
                  "
                >
                  <span class="action-item">{{ $t('botoes.laudo') }}</span>
                  <i class="icon-ic_doc-list-blue" />
                </b-button>
                <b-button
                  v-for="(anexo, i) in exame.row.Anexos"
                  :key="anexo.Codigo"
                  @click="
                    openAnexo(anexo.Codigo, exame.row.CodigoItemAtendimento)
                  "
                >
                  <span class="action-item">{{
                    $t('botoes.anexo') + ' ' + (i + 1)
                  }}</span>
                  <i class="icon-ic_download_blue" />
                </b-button>
              </div>
              <div
                v-else-if="
                  exame.row.Situacao === 'Visualizar' &&
                  !exame.row.IsExameImagem
                "
              >
                <b-button
                  @click="
                    openExamePdf(
                      exame.row.CodigoDocumento,
                      exame.row.CodigoUnidade
                    )
                  "
                >
                  <span class="action-item">{{ $t('botoes.visualizar') }}</span>
                  <i class="icon-ic_link" />
                </b-button>
              </div>
              <div
                v-else-if="
                  exame.row.Situacao === 'Visualizar' &&
                  exame.row.IsExameImagem &&
                  exame.row.UidsImagens
                "
              >
                <b-button
                  @click="openImagensExames(exame.row.UidsImagens)"
                  v-show="
                    exame.row.ExisteDicomWeb && exame.row.UidsImagens.length > 0
                  "
                >
                  <span class="action-item">{{ $t('botoes.imagens') }}</span>
                  <i class="icon-ic_eye-blue" />
                </b-button>
                <b-button
                  @click="
                    solicitarImagensExames(exame.row.CodigoItemAtendimento)
                  "
                  v-show="
                    !exame.row.ExisteDicomWeb &&
                    exame.row.UidsImagens.length > 0
                  "
                >
                  <span class="action-item">{{
                    $t('botoes.solicitar-imagens-exame')
                  }}</span>
                </b-button>
                <b-button
                  class="unavailable"
                  v-show="exame.row.UidsImagens.length == 0"
                >
                  {{ $t('exames.sem-imagem') }}
                </b-button>
              </div>
              <div
                v-else-if="exame.row.NomeExame.includes('Videofluoroscopia')"
              />
              <div v-else>
                <b-button class="unavailable">
                  {{ $t('exames.nao-liberado') }}
                </b-button>
                <i class="icon-ic_alert-red" v-show="false" />
              </div>
            </b-table-column>
          </template>
        </b-table>
      </template>
    </div>
    <form
      id="exameform"
      :action="enderecoImagens"
      method="post"
      target="_blank"
    >
      <input type="hidden" id="pacsKey" name="pacsKey" value="PACS" />
      <input
        type="hidden"
        id="patientID"
        name="patientID"
        :value="this.paciente.Prontuario"
      />
      <input type="hidden" id="studyInstanceUID" name="studyInstanceUID" />
    </form>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Breadcrumb from '../components/shared/breadcrumb/Breadcrumb'
import FilterData from '@/components/shared/filter/FilterData'
import { WindowOpener } from '../helpers/window.helper'
import router from '@/router'

export default {
  name: 'ResultadoExame',
  components: { Breadcrumb, FilterData },
  data() {
    return {
      filter: {},
      isPaginated: true,
      isPaginationSimple: false,
      paginationPosition: 'bottom',
      currentPage: 1,
      perPage: 10,
      activeClass: false,
      selectedFilter: null,
      enderecoImagens: process.env.VUE_APP_SERVER_EXAMESRAD,
      datasPesquisa: {
        dataInicio: null,
        dataTermino: null
      }
    }
  },
  computed: {
    ...mapGetters({
      getDates: 'getDateFilter',
      dadosExames: 'exames',
      examePdf: 'exameDocumento',
      isLoading: 'isLoading',
      filterData: 'examsFilter',
      laudo: 'laudo',
      anexo: 'anexo',
      paciente: 'dadosPaciente'
    })
  },
  beforeMount() {
    this.VerificarUsuario()
  },
  mounted() {
    const dataInicio = new Date()
    process.env.NODE_ENV === 'development'
      ? dataInicio.setFullYear(dataInicio.getFullYear() - 4)
      : dataInicio.setMonth(dataInicio.getMonth() - 6)
    this.datasPesquisa = {
      dataInicio: dataInicio,
      dataTermino: new Date()
    }

    this.getExames(this.datasPesquisa)
  },
  methods: {
    ...mapActions([
      'getExames',
      'getArquivoExame',
      'getLaudoPdf',
      'getAnexo',
      'solicitarImagens'
    ]),
    VerificarUsuario() {
      if (this.paciente == null) {
        router.push({ path: '/', query: { returnUrl: this.$route.path } })
      }
    },
    setFilter() {
      const dataInicio = new Date()
      process.env.NODE_ENV === 'development'
        ? dataInicio.setFullYear(dataInicio.getFullYear() - 4)
        : dataInicio.setMonth(dataInicio.getMonth() - 6)
      if (!this.datasPesquisa.dataInicio) {
        this.datasPesquisa.dataInicio = dataInicio
      }
      if (!this.datasPesquisa.dataTermino) {
        this.datasPesquisa.dataTermino = new Date()
      }

      this.getExames(this.datasPesquisa)
    },
    async openExamePdf(documento, unidade) {
      let newWin = new WindowOpener(window, navigator)
      await this.getArquivoExame({ documento, unidade }).then(() => {
        const file = new Blob([this.examePdf], { type: 'application/pdf' })
        const fileURL = URL.createObjectURL(file)
        newWin.open(fileURL)
      })
    },

    async openLaudoPDF(codigoItemAtendimento, codigoDocumento) {
      let newWin = new WindowOpener(window, navigator)
      await this.getLaudoPdf({ codigoItemAtendimento, codigoDocumento }).then(
        () => {
          const file = new Blob([this.laudo], { type: 'application/pdf' })
          const fileURL = URL.createObjectURL(file)
          newWin.open(fileURL)
        }
      )
    },

    async openAnexo(codigoAnexo, codigoItemAtendimento) {
      let newWin = new WindowOpener(window, navigator)
      await this.getAnexo({
        codigoAnexo: codigoAnexo,
        codigoItemAtendimento: codigoItemAtendimento
      }).then(() => {
        const file = new Blob([this.anexo], { type: 'application/pdf' })
        const fileURL = URL.createObjectURL(file)
        newWin.open(fileURL)
      })
    },

    submitForm(uidexame) {
      const exameForm = document.getElementById('exameform')
      exameForm.querySelector('#studyInstanceUID').value = uidexame
      exameForm.submit()
    },

    async openImagensExames(uidsImagens) {
      window.alert(
        uidsImagens.length + ' ' + this.$t('exames.aviso-abertura-janelas')
      )
      uidsImagens.forEach((element, index) => {
        setTimeout(this.submitForm, 500 * index, element)
      })
    },

    async solicitarImagensExames(codigoItemAtendimento) {
      this.solicitarImagens(codigoItemAtendimento).then(() => {
        window.alert(this.$t('exames.aviso-solicitar-imagem'))
      })
    },

    removeFilter() {
      for (let i in this.cards) {
        this.cards[i].activeClass = false
        this.$forceUpdate()
      }
      this.selectedFilter = null
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/stylesheets/base';
@import '~@/assets/stylesheets/listpagination';
@import '~@/assets/stylesheets/agenda';

.table {
  .actions {
    justify-content: space-between;
    font-weight: $font-semi-bold;
    cursor: pointer;

    .unavailable {
      cursor: not-allowed;
    }
  }
}

i {
  margin-left: 0.1875rem;
  margin-right: 0.1875rem;
}

.slider {
  i {
    font-size: 1.59375rem;
    border-radius: 50%;

    background-color: var(--neutral-color-5);
  }
}

.slider:hover {
  cursor: pointer;
}

.info_tooltip {
  display: inline-flex;

  color: var(--blue);
  font-weight: $font-semi-bold;
}
.b-tooltip:after {
  border-radius: 0.25rem;
  box-shadow: 0 0.3125rem 0.625rem 0 rgba(70, 70, 70, 0.5);
}

.title_2 {
  line-height: 1.75rem;
  font-size: 1.5rem;
  font-weight: $font-semi-bold;

  color: var(--black);
  padding-bottom: 1.875rem;

  a {
    margin-left: 0.9375rem;

    color: var(--orange);
    font-family: Roboto;
    font-size: 0.875rem;
    font-weight: $font-semi-bold;

    line-height: 1rem;
    cursor: pointer;
  }

  a:hover {
    text-decoration: underline;
  }
}

.filter_containter {
  padding-left: 3.125rem;
  padding-right: 3.125rem;
}

.filter_card:hover {
  border-color: (--light-blue);
  background-color: rgba(0, 159, 227, 0.07);
  cursor: pointer;
}

@media (max-width: 64rem) {
  .card {
    height: 6.25rem;
    width: 14.375rem;
    box-shadow: none;
    border: 0.0625rem solid $neutral-color-4;
    border-color: var(--neutral-color-4);
    border-radius: 0.25rem;

    hr {
      margin: 0.625rem;
    }

    .card-content {
      padding: 0.75rem;
    }

    .date_title {
      color: var(--light-blue);
      font-weight: $font-bold;
    }

    &.filter_card_active {
      border: 0.09375rem solid $light-blue;
      border-color: var(--light-blue);
      background-color: rgba(0, 159, 227, 0.07);
      cursor: pointer;
    }
  }
}

@media (min-width: 64rem) {
  .card {
    box-sizing: border-box;
    height: 6.25rem;
    width: 14.375rem;
    border: 0.0625rem solid $neutral-color-4;
    border-color: var(--neutral-color-4);
    border-radius: 0.25rem;

    hr {
      margin: 0.625rem;
    }

    .card-content {
      padding: 1.25rem;
    }

    .date_title {
      color: var(--light-blue);
      font-weight: $font-bold;
    }

    &.filter_card_active {
      border: 0.09375rem solid $light-blue;
      border-color: var(--light-blue);
      background-color: rgba(0, 159, 227, 0.07);
      cursor: pointer;
    }
  }
}
</style>
